import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@ibe/ui-web';

import { useSite } from '../../../shared/site-context.js';
import { useTranslation } from '../../../shared/use-translation.js';
import { SignUpForm, type SignUpInitialValues } from './sign-up-form.js';

// In-context guest registration — same contract as SignInDialog: the guest
// stays on the page (room rates, checkout) and the stored access token
// re-prices member rates, instead of routing to /auth/sign-up.
export function SignUpDialog({
  open,
  onOpenChange,
  onSignIn,
  initialValues,
}: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  /** Swaps to the sign-in dialog when the host mounts both. */
  readonly onSignIn?: (() => void) | undefined;
  /** Identity values already collected by the host (e.g. the checkout form). */
  readonly initialValues?: SignUpInitialValues | undefined;
}): React.JSX.Element {
  const { t } = useTranslation();
  const site = useSite();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[calc(100dvh-2rem)] overflow-y-auto">
        <DialogHeader className="text-center">
          <DialogTitle>{t('auth.signUp.title')}</DialogTitle>
          <DialogDescription>{t('auth.signUp.subtitle', { site: site.name })}</DialogDescription>
        </DialogHeader>
        <div className="mt-6">
          <SignUpForm
            initialValues={initialValues}
            onSuccess={() => {
              onOpenChange(false);
            }}
          />
        </div>
        {onSignIn !== undefined && (
          <p className="mt-6 text-center text-sm text-muted-foreground">
            {t('auth.alreadyHaveAccount')}{' '}
            <button
              type="button"
              onClick={onSignIn}
              className="font-semibold text-on-primary-container hover:underline"
            >
              {t('auth.signIn')}
            </button>
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
}
